export const WORK_LABELS = {
  new_installation: 'New Installation',
  router_installation: 'Router Installation',
  fiber_repair: 'Fiber Repair',
  cable_replacement: 'Cable Replacement',
  router_configuration: 'Router Configuration',
  site_survey: 'Site Survey',
  maintenance: 'Maintenance',
  other: 'Other',
};

export const STATUS_LABELS = {
  completed: 'Completed',
  pending: 'Pending',
  follow_up: 'Follow-up Required',
  customer_not_available: 'Customer Not Available',
};

export const STATUS_STYLE = {
  completed: 'bg-lime/15 text-lime',
  pending: 'bg-amber-400/15 text-amber-400',
  follow_up: 'bg-sky-400/15 text-sky-400',
  customer_not_available: 'bg-red-400/15 text-red-400',
};

export const PENDING_REASON_LABELS = {
  equipment_unavailable: 'Equipment unavailable',
  customer_absent: 'Customer absent',
  power_issue: 'Power issue',
  network_issue: 'Network issue',
  other: 'Other',
};
